import { TOUR_SHOWN_STATUS_KEY } from 'constants/localStorage';

export function getTourShownStatus() {
  return localStorage.getItem(TOUR_SHOWN_STATUS_KEY) === 'true';
}

export function setTourShownStatus(status: boolean) {
  return localStorage.setItem(TOUR_SHOWN_STATUS_KEY, String(status));
}
